import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedProductionLine = ({item}) => {
    return (
        <ExpandedComponent items={[
            {title: 'توضیحات', value: item.description},
                {title: 'محصول', value: item.product,class:'2xs:hidden '},
                {title: 'تعداد چاپ شده', value: item.printedCounter,class:'sm:hidden '},
                {title: 'ابطال', value: item.registredCounter,class:'sm:hidden '},
                {title: 'در حال بررسی', value: item.quarantineCounter,class:'md:hidden '},
                {title: 'امحا', value: item.cancleCounter,class:'2md:hidden '},
                {title: 'بازسازی شده', value: item.destroyedCounter,class:'2md:hidden '},
                {title: 'تعداد در پالت', value: item.totalReconstructCounter,class:'2md:hidden '},
                {title: 'سرپرست تولید', value: item.createBy,class:'lg:hidden '},
                {title: 'تاریخ ثبت', value: item.startTime,class:'lg:hidden '},


        ]}/>
    );
};

export default ExpandedProductionLine;